const isProd : boolean = window.location.href.includes("vw.ca");

let hr : string = 'https://qa.vwdigitalenterpriseleadsubmission.svc.vwusa.io/v1/handraiser';

if(isProd) {
  hr = 'https://prod.vwdigitalenterpriseleadsubmission.svc.vwusa.io/v1/handraiser';
}

export const appConfig = {
  api: {
    hr
  },
  campaignId: 'VWCA_IB_DC_25_VWCPOLL_HR'
};
